export enum RecordStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}
